import {
  DatePicker,
  Field,
  Input,
  RadioGroup,
  Spin,
  TextArea,
} from '@/components/commons';
import { notificationStatus } from '@/utils';
import { Badge, Form, Select } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { Moment } from 'moment';
import { useFormContext } from 'react-hook-form';
import { notificationRemindTypeOptions } from '../../NotificationRemindList';

interface IProps {
  isLoading: boolean;
}

export const NotificationForm: React.FC<IProps> = ({ isLoading }) => {
  const { trigger, watch, setValue } = useFormContext();

  const disabledDate = (current: Dayjs) => {
    return current.isBefore(dayjs().startOf('day'));
  };

  const disabledTime = (current: Dayjs) => {
    if (!current) return {};

    const now = dayjs();
    const selectedDate = dayjs(current);

    if (selectedDate.isBefore(now, 'day')) {
      return {
        disabledHours: () => Array.from({ length: 24 }, (_, i) => i),
        disabledMinutes: () => Array.from({ length: 60 }, (_, i) => i),
      };
    }

    if (selectedDate.isSame(now, 'day')) {
      const disabledHours: number[] = [];
      for (let i = 0; i < now.hour(); i++) {
        disabledHours.push(i);
      }

      const disabledMinutes = (selectedHour: number) => {
        if (selectedHour === now.hour()) {
          const minutes = [];
          for (let i = 0; i <= now.minute(); i++) {
            minutes.push(i);
          }
          return minutes;
        }
        return [];
      };

      return {
        disabledHours: () => disabledHours,
        disabledMinutes: disabledMinutes,
      };
    }

    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
    };
  };

  const isDisabled = watch('isDisabled');
  const type = watch('type');

  return (
    <Form layout='vertical'>
      <Spin spinning={isLoading}>
        <label className='title-calendar font-semibold'>
          配信日時
          <Badge status='error' className='ml-2' />
        </label>
        <div className='flex items-baseline	gap-1 pt-2'>
          <Field name='pushNotificationDate' className='flex-1'>
            <DatePicker
              disabledDate={disabledDate}
              disabledTime={disabledTime}
              showTime
              onCalendarChange={(e) => {
                setValue(
                  'pushNotificationDate',
                  e ? (e as Moment).second(0) : undefined,
                );
              }}
              disabled={isDisabled}
            />
          </Field>
        </div>
        <Field label='通知内容' name='message' required>
          <TextArea
            placeholder='通知内容ください'
            maxLength={500}
            disabled={true}
          />
        </Field>
        <Field label='ステータス' name='status' className='w-full'>
          <RadioGroup options={notificationStatus} disabled={isDisabled} />
        </Field>
      </Spin>
    </Form>
  );
};
